import React, { useEffect, useRef, useState } from "react";

// reused components
import MultiColumnFilter from "@/components/tableFIlters/MultiColumnFilter";

// Inhouse icons
import { Search, X } from "@/components/icons_new";
import OrdersExportModal from "./OrdersExportModal";

const BULK_ACTIONS = [
  "Request fulfillment",
  "Cancel fulfillment requests",
  "Mark as unfulfilled",
  "Change fulfillment location",
  "Archive orders",
  "Unarchive orders",
  "Cancel orders",
  "Add tags",
  "Remove tags",
];

const OrderSearchFilterControls = ({
  searchTerm,
  updateSearchTerm,
  filters,
  updateFilters,
  clearFilters,
  onBulkAction,
  onExport,
}) => {
  const [isBulkOpen, setIsBulkOpen] = useState(false);
  const [isExportOpen, setIsExportOpen] = useState(false);
  const bulkMenuRef = useRef(null);

  useEffect(() => {
    if (!isBulkOpen) return undefined;

    function handleClickOutside(event) {
      if (bulkMenuRef.current && !bulkMenuRef.current.contains(event.target)) {
        setIsBulkOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isBulkOpen]);

  return (
    <div className="mb-[1em] px-[0.5em] py-[0.5em] flex flex-col gap-[1em] border bg-white rounded-t-xl">
      {/* Search and action buttons row */}
      <div className="flex items-center gap-3">
        <div className="bg-[#F8F8F8] relative px-3 py-2 rounded-md flex flex-row items-center gap-[1em] w-[80%]">
          <Search className="w-5 h-5 text-[#737373]" />

          <input
            type="text"
            placeholder="Search by order ID or customer name..."
            value={searchTerm}
            onChange={(e) => {
              const raw = e.target.value;
              const sanitized = raw
                .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
                .trim()
                .slice(0, 100);
              updateSearchTerm(sanitized);
            }}
            className="w-full text-[#000] bg-[#F8F8F8] placeholder:text-[#000] outline-none font-medium"
          />

          {searchTerm && (
            <button
              onClick={() => updateSearchTerm("")}
              className="absolute right-3 text-[#999] hover:text-black"
              aria-label="Clear search"
            >
              <X className="w-5 h-5 text-[#000000]" />
            </button>
          )}
        </div>

        <div className="ml-auto flex items-center gap-2" ref={bulkMenuRef}>
          <button
            onClick={() => setIsExportOpen(true)}
            className="flex items-center gap-1 px-3 py-2 border border-gray-300 text-[#333333] rounded text-sm font-medium bg-white hover:bg-[#eeeeee]"
          >
            Export
          </button>

          <div className="relative">
            <button
              onClick={() => setIsBulkOpen((prev) => !prev)}
              className="flex items-center gap-1 px-3 py-2 border border-gray-300 text-[#333333] rounded text-sm font-medium bg-white hover:bg-[#eeeeee]"
            >
              Bulk actions
            </button>

            {isBulkOpen && (
              <div className="absolute right-0 mt-2 w-56 rounded-lg border border-gray-200 bg-white shadow-lg z-50">
                <div className="p-1">
                  {BULK_ACTIONS.map((action) => (
                    <button
                      key={action}
                      onClick={() => {
                        setIsBulkOpen(false);
                        onBulkAction?.(action);
                      }}
                      className="w-full rounded-md font-medium text-left px-4 py-2 text-sm text-[#333333] hover:bg-[#bdbdbd31]"
                    >
                      {action}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* filter control */}
      <MultiColumnFilter
        filterFields={[
          {
            key: "orderStatus",
            label: "Order Status",
            options: ["Processing", "Delivered", "Cancelled"],
          },
          {
            key: "paymentStatus",
            label: "Payment Status",
            options: ["Paid", "Pending", "Failed"],
          },
          {
            key: "salesChannel",
            label: "Sales Channel",
            options: ["POS", "Online"],
          },
        ]}
        selectedFilters={filters}
        onChange={updateFilters}
        onClearAll={clearFilters}
        showBulkActions={false}
      />

      <OrdersExportModal
        isOpen={isExportOpen}
        onClose={() => setIsExportOpen(false)}
        onExport={onExport}
      />
    </div>
  );
};

export default OrderSearchFilterControls;